import HeroBreadCrumb from "../../components/BreadCrumb/HeroBreadCrumb";
import ContentBlock from "../../components/ContentBlock/ContentBlock";
import Paragraph from "../../components/Paragraph/Paragraph";
import { AboutContent } from "./About-Content";

const About: React.FC = () => {
  return (
    <>
        <HeroBreadCrumb
            content={AboutContent.heroBreadCrumb}
            style={{minHeight: '21.875rem'}}
        />

        <section className="container pt-4">
            <Paragraph
                isPageHeader={true}
                content={AboutContent.paragraph1}
            />
        </section>

        <section className="container pt-4">
            <Paragraph
                isPageHeader={false}
                content={AboutContent.paragraph2}
            />
        </section>

        <section className="container pt-4">
            <Paragraph
                isPageHeader={false}
                content={AboutContent.paragraph3}
            />
        </section>

        <section className="container pt-4">
            <Paragraph
                isPageHeader={false}
                content={AboutContent.paragraph4}
            />
        </section>

        <section className="container py-4">
            <ContentBlock
                content={AboutContent.contentBlock1}
            />
        </section>

        <section className="container py-4">
            <ContentBlock
                blockClass="bg-light-grey box-custom-shadow-2 text-center px-4 py-3"
                content={AboutContent.contentBlock2}
            />
        </section>

        <section className="container py-4">
            <ContentBlock
                content={AboutContent.contentBlock3}
            />
        </section>
    </>
  );
}

export default About;
